import React from 'react';
import {
  Button,
  ButtonLoading,
  Heading,
  TrevorIcon,
} from '@trevor/ui-components';
import { useModalClose } from '@/features/modals/modalSlice';
import {
  ModalContentContainer,
  ModalFooterControlsContainer,
} from './ModalSystem.styles';
import { ModalRenderer } from './ModalRenderer';
import { TModalVPosition, TModalWidthType } from './types';

export type ModalProps = {
  title?: string;
  widthType?: TModalWidthType;
  vPosition?: TModalVPosition;
  className?: string;
} & (
  | { noDefaultFooter: true }
  | {
      noDefaultFooter?: boolean;
      onSubmit: F0;
      isSubmitDisabled?: boolean;
      isCancelDisabled?: boolean;
      submitText?: string;
      cancelText?: string;
      submitLoading?: boolean;
    }
);
export const Modal: React.FC<ModalProps> = ({
  children,
  title,
  widthType = 'md',
  vPosition = 'top',
  className,
  ...rest
}) => {
  const handleClose = useModalClose();

  return (
    <ModalRenderer>
      <ModalContentContainer
        widthType={widthType}
        vPosition={vPosition}
        className={className}
      >
        <Heading variant={3}>
          {title}
          <Button
            variant="secondary"
            size="small"
            icon={<TrevorIcon name="close" />}
            onClick={handleClose}
          />
        </Heading>

        {children}
        {!rest.noDefaultFooter && (
          <ModalFooterControlsContainer>
            <Button
              variant="secondary"
              onClick={handleClose}
              disabled={rest.isCancelDisabled}
            >
              {rest.cancelText ?? 'Cancel'}
            </Button>
            <ButtonLoading
              id="btnModalSubmit"
              onClick={rest.onSubmit}
              disabled={rest.isSubmitDisabled}
              loading={rest.submitLoading}
            >
              {rest.submitText ?? 'Submit'}
            </ButtonLoading>
          </ModalFooterControlsContainer>
        )}
      </ModalContentContainer>
    </ModalRenderer>
  );
};
